// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.court-section h4 {
  margin-bottom: 0.5rem;
}

.court-section ul {
  margin-bottom: 0.5rem;
}

.client-cases {
  margin-top: 2rem;
}
.client-cases .caseids {
  cursor: pointer;
}
.client-cases h3 {
  font-size: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--text-dark);
  margin-bottom: 0.5rem;
}
.client-cases ul {
  padding-left: 1rem;
  list-style-type: disc;
}
.client-cases ul li {
  color: var(--text-dark);
  font-size: 0.95rem;
  margin-bottom: 0.25rem;
}

.court-section:not(:first-child) {
  margin-top: 0.75rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/ViewLabel/ViewLabel.scss"],"names":[],"mappings":"AACA;EACE,qBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAIA;EACE,gBAAA;AADF;AAEE;EACE,eAAA;AAAJ;AAGE;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,qBAAA;AADJ;AAIE;EACE,kBAAA;EACA,qBAAA;AAFJ;AAII;EACE,uBAAA;EACA,kBAAA;EACA,sBAAA;AAFN;;AAQA;EACE,mBAAA;AALF","sourcesContent":["// Add spacing between headings and lists, and between court sections\r\n.court-section h4 {\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.court-section ul {\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n// Add equal spacing before each court section except the first\r\n.client-cases  {\r\n  margin-top: 2rem;\r\n  .caseids{\r\n    cursor: pointer;\r\n  }\r\n\r\n  h3 {\r\n    font-size: 1rem;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.5rem;\r\n    color: var(--text-dark);\r\n    margin-bottom: 0.5rem;\r\n  }\r\n\r\n  ul {\r\n    padding-left: 1rem;\r\n    list-style-type: disc;\r\n\r\n    li {\r\n      color: var(--text-dark);\r\n      font-size: 0.95rem;\r\n      margin-bottom: 0.25rem;\r\n    }\r\n  }\r\n}\r\n\r\n// Add equal top margin to all court sections except the first\r\n.court-section:not(:first-child) {\r\n  margin-top: 0.75rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
